import { Stack } from 'expo-router'

export default function AuthLayout() {
    return (
        <Stack
            screenOptions={{
                headerShown: false,
            }}
        >
            <Stack.Screen name="sign-up" options={{ title: 'Create Account' }} />
            <Stack.Screen name="sign-in" options={{ title: 'Welcome Back' }} />
            <Stack.Screen name="reset" options={{ title: 'Reset Password' }} />
            <Stack.Screen name="reset-password" options={{ title: 'Reset Password' }} />
            <Stack.Screen
                name="accept-invitation/[inviteId]"
                options={{ title: 'Accept Invitation' }}
            />
        </Stack>
    )
}
